<template>
  <section class="hero">
    <AppFigure
      class="hero__image"
      :data="{ src: data.src, alt: data.alt }"
      :isLazy="false"
    />
  </section>
</template>

<script>
import AppFigure from '@/components/AppFigure.vue';

export default {
  name: 'pageHero',

  components: {
    AppFigure,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.hero {
  position: relative;
  width: 100%;
  height: 100vh;
  margin-bottom: 80px;

  @include mq(ipadP) {
    margin-bottom: 160px;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    @include mq($and: $is-not-touch-device) {
      &::v-deep .picture__div-img {
        background-attachment: fixed;
      }
    }

    &::after {
      content: '';

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-color: rgba(rgb(37, 31, 26), 0.7);
    }
  }
}

</style>
